export const API_BASE_URL = "https://yg9j01gyv0.execute-api.ca-central-1.amazonaws.com";
export const CAPTCHA_SITE_KEY = "0x4AAAAAACi1y_5a5UmgYJw4";

